export const environment = {
  production: false,

  clientName: 'demo',
  apiGatewayFront: 'https://siesaagp.aceitesa.com/',
  apiGatewayBackOffice: 'https://siesaagp.aceitesa.com/',
  apiUrl: 'https://siesaagp.aceitesa.com/',
  urlPath: 'https://siesaagp.aceitesa.com/',
  customCss: false,
  // Whether or not to enable debug mode
  // Setting this to false will disable console output
  enableDebug: false,
  // siteKeyCaptcha: '6LdLtBsgAAAAAJksLT4W-TI-oRed7Uk9B8Y-EECB', DEMO
  // siteKeyCaptcha: '6LfL5fkfAAAAALmrMTjEg18wnQm5uR3ZNbBy-pL7' ZX

  siteKeyCaptcha: '6LdoivolAAAAAHYBowT7QmSImOfNyDBBgWTU3mOA',

  googleAnalyticsCode: 'UA-140785247-1',
};